// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".green_button{padding:.25rem .75rem}.v-data-table th{white-space:nowrap}.green-dot{display:inline-block;width:8px;height:8px;background-color:#22c55e;border-radius:50%}", ""]);
// Exports
module.exports = exports;
